import slick from 'slick-carousel'

const $logos = $('.client-logo-grid')

const setupSlider = () => {
  $logos.slick({
    arrows: false,
    mobileFirst: true,
    autoplay: true,
    slidesToShow: 2,
    responsive: [
      {
        breakpoint: 639,
        settings: {
          slidesToShow: 3
        }
      },
      {
        breakpoint: 1023,
        settings: {
          slidesToShow: 6
        }
      }
    ]
  })
}

export default {
  can: () => $logos.length,
  run: () => {
    setupSlider()
  }
}
